import { OpenInvoicesTable } from '@/components/Templates/Invoices';

const OpenInvoices = () => {
	return <OpenInvoicesTable />;
};

export default OpenInvoices;